import { UserRole } from '@shared/enums/user-role.enum';
import { UserContext, UserContextResponse } from '@core/models/user-context.model';

export const resolveUserRole = (context: UserContextResponse): UserRole => {
    const user = context.user;
    if (user?.admin) {
        return UserRole.ADMIN;
    }
    if (user?.productManager) {
        return UserRole.PM;
    }
    if (user?.userType === 'Trainer') {
        return UserRole.TRAINER;
    }
    return UserRole.APPRENTICE;
};

export const toUserContext = (response: UserContextResponse): UserContext => ({
    role: resolveUserRole(response),
    country: response.user?.country ?? null
});
